export const isUserDeleted = (createdAt) => {
  const now = new Date().getTime();
  const thirtyDays = 1_000 * 60 * 60 * 24 * 30;
  return createdAt < now - thirtyDays;
};
